/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';
import { getEventNavbarSponsors } from '@e180/domain/lib/event/util';

import BrandingDumb from './BrandingDumb';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

const mapStateToProps = (state: State): Object => {
  const navbarSponsors = getEventNavbarSponsors(getEventSafely(state));

  return { isSponsorShown: !!navbarSponsors && navbarSponsors.length > 0 };
};

export default compose(connect(mapStateToProps))(BrandingDumb);
